import { create } from 'zustand';

export interface ChatMessage {
  author?: {
    premiumUntil?: string;
    username: string;
    avatar?: string;
    role?: string;
    id: string;
  };
  type?: 'LEFT_CHAT' | 'HELP_BOT' | 'NORMAL';
  channelId?: string;
  createdAt: string;
  content: string;
  id: string;
}

export interface ChatChannel {
  participants: {
    user: {
      username: string;
      avatar: string;
      id: string;
    }
  }[];
  type: 'GLOBAL' | 'DIRECT' | 'HELP';
  messages: ChatMessage[];
  id: string;
}

interface ChatState {
  setActiveChannelId: (activeChannelId: string) => void;
  removeUnreadChannel: (channelId: string) => void;
  addLobbyMessage: (message: ChatMessage) => void;
  addUnreadChannel: (channelId: string) => void;
  setMessages: (message: ChatMessage[]) => void;
  setChannels: (channel: ChatChannel[]) => void;
  addMessages: (message: ChatMessage[]) => void;
  addChannels: (channel: ChatChannel[]) => void;
  removeChannel: (channelId: string) => void;
  lobbyMessages: ChatMessage[];
  unreadChannels: string[];
  activeChannelId: string;
  messages: ChatMessage[];
  channels: ChatChannel[];
}

export const useChatStore = create<ChatState>()(
  (set) => ({
    messages: [],
    channels: [],
    lobbyMessages: [],
    unreadChannels: [],
    activeChannelId: '',
    setMessages: (messages) => set({ messages }),
    setChannels: (channels) => set({ channels }),
    setActiveChannelId: (activeChannelId) => set({ activeChannelId }),
    addMessages: (message) => set((state) => ({ messages: [...state.messages, ...message] })),
    addChannels: (channel) => set((state) => ({ channels: [...state.channels, ...channel] })),
    addLobbyMessage: (message) => set((state) => ({ lobbyMessages: [...state.lobbyMessages, message] })),
    addUnreadChannel: (channelId) => set((state) => ({ unreadChannels: [...state.unreadChannels, channelId] })),
    removeChannel: (channelId) => set((state) => ({ channels: state.channels.filter((channel) => channel.id !== channelId) })),
    removeUnreadChannel: (channelId) => set((state) => ({ unreadChannels: state.unreadChannels.filter((channel) => channel !== channelId) })),
  }),
);